import React from 'react';

import { Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import {
  setReviewerSameSettingAsFeedbackFormId,
  useReviewCreationData,
  useReviewers,
  useReviewersSameSetting,
} from 'reducers/reviewCreationSlice';

import { useGetReviewers, useSaveReviewers } from '../../Hooks/dataHooks/reviewersDataHooks';
import { ReviewCreationFooter } from '../../ReviewCreationFooter';
import { MultiViewStepAccordionWrapper } from '../../components/MultiViewStepAccordionWrapper';
import { SkeletonLoaderMultiViewVariant } from '../../components/SkeletonLoaderReviewCreation';
import { ManagerSettings } from './ManagerSettings';
import { PeerNominationSettings } from './PeerNominationSettings';
import { ReviewersSection } from './ReviewersSection';

const Footer = () => {
  const reviewersViews = useReviewers();
  const saveDataMutation = useSaveReviewers();
  const isContinueDisabled = reviewersViews?.length === 0 || saveDataMutation.isLoading;

  const handleContinue = () => {
    saveDataMutation.mutate();
    console.log('continue');
  };

  return <ReviewCreationFooter isContinueDisabled={isContinueDisabled} onContinue={handleContinue} />;
};

const SingleViewSettings = ({ view, feedbackFormId, feedbackFormName, index: viewIndex, singleViewOnly }) => {
  const settingSameAsFormId = useReviewersSameSetting({ feedbackFormId });

  const dispatch = useDispatch();

  const reviewersViews = useReviewers();
  const firstViewName = reviewersViews?.[0]?.feedbackFormName;
  const firstFeedbackFormId = reviewersViews?.[0].feedbackFormId;

  const { isAllowSameSettingAsFirstView } = reviewersViews[viewIndex];

  const onChangeHandler = () => {
    dispatch(
      setReviewerSameSettingAsFeedbackFormId({
        feedbackFormId,
        settingSameAsFormId: settingSameAsFormId ? null : firstFeedbackFormId,
      })
    );
  };

  if (singleViewOnly) {
    return (
      <Flex flexDirection="column" gap={4}>
        <ReviewersSection feedbackFormId={feedbackFormId} />
        <ManagerSettings feedbackFormId={feedbackFormId} />
        <PeerNominationSettings feedbackFormId={feedbackFormId} />
      </Flex>
    );
  }

  return (
    <MultiViewStepAccordionWrapper
      firstViewName={firstViewName}
      onChangeHandler={onChangeHandler}
      settingSameAsFormId={settingSameAsFormId}
      view={view}
      index={viewIndex}
      isAllowSameSettingAsFirstView={isAllowSameSettingAsFirstView}
      feedbackFormName={feedbackFormName}
    >
      <Flex flexDirection="column" gap={4}>
        <ReviewersSection feedbackFormId={feedbackFormId} />
        <ManagerSettings feedbackFormId={feedbackFormId} />
        <PeerNominationSettings feedbackFormId={feedbackFormId} />
      </Flex>
    </MultiViewStepAccordionWrapper>
  );
};

const Reviewers = () => {
  const { reviewCycleId } = useReviewCreationData();
  const reviewerViewWiseSettings = useReviewers();
  const { isLoading, isSuccess } = useGetReviewers({ reviewCycleId });

  if (isLoading) {
    return <SkeletonLoaderMultiViewVariant />;
  }
  if (!isSuccess || reviewerViewWiseSettings.length === 0) return null;

  return (
    <>
      {reviewerViewWiseSettings.map(({ cohort, feedbackFormId, feedbackFormName }, index) => (
        <SingleViewSettings
          view={cohort}
          index={index}
          singleViewOnly={reviewerViewWiseSettings.length === 1}
          feedbackFormId={feedbackFormId}
          feedbackFormName={feedbackFormName}
        />
      ))}
      <Footer />
    </>
  );
};

export { Reviewers };
